<template>
  <div class="exr-pdt">
    <el-form-item class="exr-items"  label="选项">
      <PdtItem v-for="(value, key) in form.leftItems" :key="key" :left-item.sync="form.leftItems[key]" :right-item.sync="form.rightItems[key]" :config="config">
        <template #append>
          <el-button type="danger" tabindex="-1" icon="el-icon-delete" @click="removeItem(key)"></el-button>
          <el-button icon="el-icon-plus" tabindex="-1" v-if="showAddItem" @click="addItem(key)"></el-button>
        </template>
      </PdtItem>
    </el-form-item>
  </div>
</template>

<script>
  import basepdt from './base-pdt.js'
  import utils from '../../../js/utils'
  import PdtItem from './pdt';

  export default {
    name: 'PdtForm',
    components: {
      PdtItem
    },
    data() {
      return {
        //1词汇 2句子 3拼音 4词汇+拼音 5句子+拼音 6图片 7音频 8翻译
        type: {words: 1, line: 2, pinyin: 3, words_pinyin: 4, line_pinyin: 5, image: 6, audio: 7, translation: 8},
        left_type : '',
        right_type : '',
      }
    },
    mixins: [basepdt],
    created() {
      this.initType()
    },
    watch: {
      'form.leftItems.length': {
        deep:true,
        handler(form) {
          this.updateForm()
        }
      },
      'config': {
        deep:true,
        handler(form) {
          this.initType()
        }
      }
    },
    methods: {
      initType() {console.log(this.config)
        this.left_type = this.type[this.config.leftItems]
        this.right_type = this.type[this.config.rightItems]
        this.updateForm()
      },
      updateForm() {
        this.form.leftItems.forEach((item, index) => {
          item.type = this.left_type;
        })
        this.form.rightItems.forEach((item, index) => {
          item.type = this.right_type;
        })
        console.log(this.form)
      },
      getFileUrl(file) {
        return utils.url(file)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .exr-items::v-deep {
    margin-bottom: 20px;
    .exr-pdt-item {
      display: flex;
      > .el-button{
        width: 40px;
        padding: 0;
        line-height: 40px;
        text-align: center;
        margin-left: 8px;
      }
      +.exr-pdt-item {
        margin-top: 8px;
      }
    }
    .exr-item{
      width: 100%;
      > .el-radio{
        margin-right: 0;
      }
      > .el-input{
        flex: 1;
      }
      > .file-input{
        flex: 1;
      }
      .el-select {
        flex: 1;
      }
      .exr-item-wrap-file {
        height: 38px;
        border: 1px solid #DCDFE6;
        border-radius: 4px;
        margin-top: 3px;
        audio {
          height: 38px;
        }
      }
    }
    .exr-item-wrap {
      display: flex;
      flex: 1;
    }
    .exr-item-wrap + .exr-item-wrap{
      margin-left: 8px;
    }
    .exr-item-wrap > .popover-preview.offset-form{
      left: 69px;
    }
    .exr-item-image {
      flex: 2;
    }
    .exr-item-image, .exr-item-audio {
      height: 83px;
      border: 1px solid #DCDFE6;
      border-radius: 4px;
      margin-left: 8px;
      text-align: center;
      display: flex;
      img {
        max-height: 100%;
        max-width: 100%;
      }
      audio{
        height: 38px;
      }
    }
    .exr-item-left.exr-item-image, .exr-item-left.exr-item-audio {
      border: 0;
    }
    .pinyin-input {
      margin-top: 5px;
    }
  }
</style>
